/* global axios */
import ApiClient from './ApiClient';

class ProtocolCategoriesAPI extends ApiClient {
  constructor() {
    super('protocol_categories', { accountScoped: true });
  }

  // Category steps (template)
  getSteps(categoryId) {
    return axios.get(`${this.url}/${categoryId}/steps`);
  }

  createStep(categoryId, data) {
    return axios.post(`${this.url}/${categoryId}/steps`, data);
  }

  updateStep(categoryId, stepId, data) {
    return axios.patch(`${this.url}/${categoryId}/steps/${stepId}`, data);
  }

  deleteStep(categoryId, stepId) {
    return axios.delete(`${this.url}/${categoryId}/steps/${stepId}`);
  }
}

export default new ProtocolCategoriesAPI();
